<template>
  <portal to="footer">
    <v-container ma-0 pa-1 pr-3 pl-3 fluid>
      <slot name="center">
        <v-layout justify-space-between>
          <v-flex v-if="$slots['left']" class="text-left">
            <slot name="left" />
          </v-flex>

          <v-flex class="text-right">
            <slot />
          </v-flex>
        </v-layout>
      </slot>
    </v-container>
  </portal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
/**
 * Footer that has a contrasting background and allows positioning of buttons.
 */
export default defineComponent({
  name: "BmPageFooter",
});
</script>

<style scoped lang="sass">
@import "src/sass/colours"

.bm-page-footer
  background-color: $bm-color-background01
  width: 100%
</style>
